t = require('app/scripts/views/internal/teacup-with-helpers')('attachment_viewer')

module.exports = ->
  t.div '.attachment-viewer-header.js-close-viewer', ->
    t.span '.icon-lg.icon-close.attachment-viewer-header-close-icon'

  t.div '.attachment-viewer-underlay.js-close-viewer'

  t.div '.attachment-viewer-frames.js-frames'

  t.div '.attachment-viewer-overlay', ->
    t.div '.attachment-viewer-frame-details.js-display-frame-details'

  t.a '.attachment-viewer-next-frame-btn.js-show-next-frame', ->
    t.span '.icon-lg.icon-forward.light.attachment-viewer-next-frame-btn-icon'

  t.a '.attachment-viewer-prev-frame-btn.js-show-prev-frame', ->
    t.span '.icon-lg.icon-back.light.attachment-viewer-prev-frame-btn-icon'
